/**
 * @requires ./frc.js
 * @requires ./frc.utilities.js
 *
 */

frc.modules.groupDining = function ($module) {
    var self = this;
    self.config = {};
    self.data = {
        "$module": null,
        "$form": null,
        "version": null
    };

    if ((typeof $module) == "string") {
        $module = $($module);
    }

    self.data.$module = $module;

    self.init = function () {
        // $pdrModal = $("#group-dining-modal #iframe-parent iframe");
        // let buffer = 425;

        // // Lower the buffer if on a mobile device, as to keep as much screen real estate as possible
        // if (frc.utilities.isMobileDevice()) {
        //     buffer = 170;
        // }
        // // Resize TripleSeat iframe to fit inside our modal on page load
        // $pdrModal.height(window.innerHeight - buffer);

        // // Resize iframe on window resize
        // var resizeId;
        // window.addEventListener('resize', function () {
        //     clearTimeout(resizeId);
        //     resizeId = setTimeout(afterWindowResize, 100);
        // });

        // function afterWindowResize() {
        //     $pdrModal.height(window.innerHeight - buffer);
        // }
    }

    self.init();
    return self;
}
